import { render, staticRenderFns } from "./endPoint.md?vue&type=template&id=3a716284&"
import script from "./endPoint.md?vue&type=script&lang=js&"
export * from "./endPoint.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a716284')) {
      api.createRecord('3a716284', component.options)
    } else {
      api.reload('3a716284', component.options)
    }
    module.hot.accept("./endPoint.md?vue&type=template&id=3a716284&", function () {
      api.rerender('3a716284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/line/endPoint.md"
export default component.exports